import * as React from 'react';
import { FIELD_CLASSES } from '@/components/ui/field-styles';
import { cn } from '@/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content min-h-16 w-full rounded-md px-3 py-2 text-base placeholder:text-muted-foreground/80 md:text-sm',
        FIELD_CLASSES,
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
